import P from "components/P";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import SquareWrapper from "layouts/wrapper/SquareWrapper";
import scan from 'resources/img/signup.png';
import cart from 'resources/img/cart.png';
import icon1 from 'resources/img/Group 50.png';
import banner from 'resources/img/avocado.jpg';
import { QRCodeSVG } from 'qrcode.react';
import favicon from "resources/img/favicon.ico";
import NiceModal from "@ebay/nice-modal-react";
import { useNavigate, useParams } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import Inline from "layouts/container/Inline";
import Center from "layouts/wrapper/Center";

import { OutletContext, SignUpQR } from "./main/WebSocketContainer";
import { useContext, useEffect, useRef } from "react";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import Dummy from "components/Dummy";
import MobileHome from "./MobileHome";
import signUpSound from "resources/music/homeSignUpSound.mp3";
import puffuIcon from "resources/img/puffu/puffuIconsvg.svg";
import videoFile from "resources/video/main.mp4";

function Home() {
    const { id } = useContext(OutletContext);
    const navigate = useNavigate();
    const audioRef = useRef();
    const deviceCode = window.BRIDGE && window.BRIDGE.getDeviceCode ? window.BRIDGE.getDeviceCode() : "";
    const SignUpQR = () => {
        return (
            <QRCodeSVG
                // value={"puffu://action"}
                // value={`${window.location.origin}/ws/${id}/signUp`}
                // value={"puffu://MainScreen"}
                value={`https://puffuapp.com/ws/${id}/vendingSignIn?deviceCode=${deviceCode}`}
                // value={`http://puffuapp.com/ws/${id}/vendingSignIn?deviceCode=${deviceCode}`}
                size={256}
                bgColor={"#ffffff"}
                // bgColor={"#fe5b35"}
                fgColor={"#000000"}
                level={"L"}
                includeMargin={true}
            // imageSettings={{
            //     src: favicon,
            //     x: undefined,
            //     y: undefined,
            //     height: 48,
            //     width: 48,
            //     excavate: true,
            // }}
            />
        );
    }
    const Button = ({ background, backgroundColor, boxShadow, text, color, img, element, url, border, text2 }) => {
        return (
            <div style={{ userSelect: "none", cursor: "pointer", border: border && border, borderRadius: "20px", height: "350px" }}>
                {/* <SquareWrapper width={"100%"}> */}
                <div style={{ background: background, width: "100%", height: "100%", borderRadius: "20px", backgroundColor: backgroundColor, boxShadow: `1px 1px 2.5999999046325684px 0px ${boxShadow}` }}>
                    <HorizontalFlex gap={"5%"}>

                        <FlexChild height={"30%"} width={"max-content"} >
                            {

                                img
                                    ?
                                    <div style={{ padding: "30px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        <img src={img} width={"80%"} alt="" style={{ height: "100%", borderRadius: "20px" }} />
                                    </div>
                                    :
                                    <div style={{ padding: "30px" }}>
                                        {element}
                                    </div>
                            }
                        </FlexChild>
                        <FlexChild>
                            <Center width={"100%"} textAlign={"left"}>
                                <P color={color} size={"4.3vw"} weight={"bold"}>{text}</P>
                                <Dummy height={"15px"} />
                                <P color={color} size={"2.5vw"} weight={500}>{text2}</P>
                            </Center>
                        </FlexChild>
                    </HorizontalFlex>
                </div>
                {/* </SquareWrapper> */}
            </div>
        );
    }

    // const onSignUpClick = () => {
    //     if (window.BRIDGE && window.BRIDGE.testAndroid) {
    //         window.BRIDGE.testAndroid();
    //     }

    // }

    const onStartClick = () => {
        navigate(`/ws/${id}/main`);
    }

    const button = {
        rest: { scale: 1 },
        hover: { scale: 1.1 },
        pressed: { scale: 0.95 }
    };

    const arrow = {
        rest: { rotate: 0 },
        hover: { rotate: 360, transition: { duration: 0.4 } }
    };

    useEffect(() => {
        // return audioRef.current.play();
    }, [])

    return (

        <AnimatePresence>
            <motion.div
                className="box"
                initial={{ scale: 0.5 }}
                animate={{ scale: 1 }}
            >
                <Container height={"100vh"}>
                    <audio ref={audioRef} src={signUpSound} preload="auto" />
                    <VerticalFlex>
                        <FlexChild>
                            <VerticalFlex gap={"5%"}>
                                <FlexChild height={"1%"}></FlexChild>
                                <FlexChild height={"20%"}>
                                    <VerticalFlex gap={"5%"}>
                                        <FlexChild />
                                        <FlexChild>
                                            <P size={"5vw"} weight={"bold"} color={"#FE531F"}>반가워요!</P>


                                            <P size={"4.7vw"} weight={"900"}>24시간 언제나 간편한 무인 매장 푸푸입니다!</P>

                                        </FlexChild>
                                        <FlexChild>
                                            <P size={"3vw"} color={"#797979"}>PUFFU 회원가입하고 웰컴 기프트와 할인 혜택을 받아보세요!</P>
                                        </FlexChild>
                                    </VerticalFlex>
                                </FlexChild>
                                <FlexChild>
                                    <VerticalFlex>

                                        <FlexChild width={"80%"}>
                                            <div style={{ position: "relative", userSelect: "none", border: "2px solid var(--point-color)", borderRadius: "20px", height: "350px" }}>
                                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", position: "absolute", width: "100px", top: -10, right: -10, backgroundColor: "white", padding: "5px", height: "100px" }}>

                                                    <img src={puffuIcon} />
                                                </div>
                                                <div style={{ width: "100%", height: "100%", borderRadius: "20px" }}>
                                                    <HorizontalFlex>
                                                        <FlexChild height={"30%"} width={"max-content"} >
                                                            <div style={{ padding: "30px" }}>
                                                                <SignUpQR />
                                                            </div>
                                                        </FlexChild>
                                                        <FlexChild>
                                                            <VerticalFlex flexStart gap={30}>
                                                                <FlexChild>
                                                                    <div style={{ backgroundColor: "var(--point-color)", width: "max-content", padding: "5px 20px" }}>
                                                                        <P weight={700} size={"3vw"} color={"white"}>푸푸오더로 미리 주문한 경우</P>
                                                                    </div>
                                                                </FlexChild>
                                                                <FlexChild>
                                                                    <P size={"2.2vw"} weight={500}>푸푸 어플리케이션 접속 후 QR코드 스캔</P>
                                                                    <P size={"2.2vw"} weight={500}>버튼을 눌러 좌측의 QR코드를 스캔해주세요.</P>
                                                                </FlexChild>
                                                            </VerticalFlex>
                                                        </FlexChild>
                                                    </HorizontalFlex>
                                                </div>
                                            </div>
                                        </FlexChild>

                                        <FlexChild width={"80%"}>
                                            <motion.div
                                                className="refresh"
                                                variants={button}
                                                initial="rest"
                                                whileHover="hover"
                                                whileTap="pressed"
                                                onClick={onStartClick}
                                            >
                                                <Button background={"linear-gradient(180deg, #F6F8FF 0%, #EAEFFF 100%)"} boxShadow={"#00000033"} text={"상품 바로보기"} text2={"푸푸의 다양한 상품을 바로 구매해보세요!"} color={"black"} img={icon1} />
                                            </motion.div>
                                        </FlexChild>
                                    </VerticalFlex>
                                </FlexChild>


                                {/* <FlexChild>
                                    <VerticalFlex gap={20}>
                                        <FlexChild height={"max-content"}>
                                            <div style={{ width: "80%", height: "5px", backgroundColor: "#FE531F" }} />
                                        </FlexChild>
                                        <FlexChild width={"80%"}>
                                            <HorizontalFlex gap={20}>
                                                <FlexChild width={"max-content"}>
                                                    <div style={{ position: "relative", width: "6vw", height: "6vw", backgroundColor: "#FE531F", borderRadius: "50%" }}>
                                                        <Center>
                                                            <P weight={"bold"} size={"min(36px, 3vw)"} color={"#FFFFFF"}>1</P>
                                                        </Center>
                                                    </div>
                                                </FlexChild>
                                                <FlexChild >
                                                    <P weight={500} size={"min(36px, 2.5vw)"}> PUFFU앱 로그인 후 마이페이지에 들어갑니다.</P>
                                                </FlexChild>
                                            </HorizontalFlex>
                                        </FlexChild>
                                        <FlexChild height={"max-content"}>
                                            <div style={{ width: "80%", height: "5px", backgroundColor: "#FE531F" }} />
                                        </FlexChild>

                                        <FlexChild width={"80%"}>
                                            <HorizontalFlex gap={20}>
                                                <FlexChild width={"max-content"}>
                                                    <div style={{ position: "relative", width: "6vw", height: "6vw", backgroundColor: "#FE531F", borderRadius: "50%" }}>
                                                        <Center>
                                                            <P weight={"bold"} size={"min(36px, 3vw)"} color={"#FFFFFF"}>2</P>
                                                        </Center>
                                                    </div>
                                                </FlexChild>
                                                <FlexChild>
                                                    <P size={"min(36px, 2.5vw)"}> 상단 본인인증 QR을 눌러 자판기 QR리더기에 인식합니다.</P>
                                                </FlexChild>
                                            </HorizontalFlex>
                                        </FlexChild>
                                        <FlexChild>
                                            <div style={{ width: "80%", height: "5px", backgroundColor: "#FE531F" }} />
                                        </FlexChild>
                                    </VerticalFlex>
                                </FlexChild> */}
                            </VerticalFlex>
                        </FlexChild>
                        <FlexChild width={"100%"} height={"35.8%"} overflow={"hidden"} backgroundColor={"#CA1208"}>
                            {/* <img src={banner} alt="" style={{ height: "100%" }} /> */}
                            <video autoPlay loop style={{ width: "100%", height: "100%" }} muted={true}>
                                    <source src={videoFile} type="video/mp4" />
                                </video>
                            {/* <div style={{height: "100%", backgroundColor: "#CA1208"}}></div> */}
                        </FlexChild>
                    </VerticalFlex>
                </Container>
            </motion.div>
        </AnimatePresence>
    );
}

export default Home;